type ModulePlaceholderPageProps = {
  label: string;
  description?: string;
};

export function ModulePlaceholderPage({ label, description }: ModulePlaceholderPageProps) {
  return (
    <section className="module-placeholder">
      <span className="eyebrow">V2 FOUNDATION</span>
      <h2>{label}</h2>
      <p>{description || "Ten moduł zostanie zbudowany po zmapowaniu jego kontraktów z develop-v1."}</p>
      <button className="secondary-button" type="button">Zobacz plan migracji</button>
    </section>
  );
}
